// src/tools/drawing/plotTool.js

export const plotTool = {
  // Храним функции управления рисованием
  _startDrawing: null,
  _stopDrawing: null,

  initialize: (map, options) => {
    console.log('Plot tool initialized with options:', options);
    // Сохраняем переданные функции
    if (options.drawingControls) {
      plotTool._startDrawing = options.drawingControls.startDrawing;
      plotTool._stopDrawing = options.drawingControls.stopDrawing;
    }
  },
  activate: (type, defaultProperties) => {
      console.log('Plot tool activated');
      // При активации включаем режим рисования полигонов с указанным типом
      plotTool._startDrawing?.('polygon', defaultProperties);
  },
  deactivate: () => {
    console.log('Plot tool deactivated');
    // При деактивации выключаем режим рисования
    plotTool._stopDrawing?.();
  },
  cleanup: () => {},
};